// extracted by mini-css-extract-plugin
export default {"img1":"Home_img1__U3Ert","img2":"Home_img2__fg7BX","img3":"Home_img3__I7ok6","courseImg":"Home_courseImg__aibKs","courseLink":"Home_courseLink__eGIWd","img4":"Home_img4__ufm7o"};